import { Button, Grid, Icon } from 'gu-ui-kit'
import React from 'react'

export const ActionsCell = () => (
  <Grid gap={16} justifyContent={'end'}>
    <Button
      variant={'ghost'}
      size={'l'}
      startIcon={<Icon name="settings" color={'Interface-Eighth'} />}
    />
  </Grid>
)
